import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, API_BASE } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Download, Smartphone, ShieldCheck, BellRing } from "lucide-react";

// Pagina publica (sem login) para baixar o app Android: /app
// O acesso ao app continua exigindo login de empresa com o modulo App.
export default function AppDownload() {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get("/mobile/version")
      .then(({ data }) => setInfo(data))
      .catch(() => setError(true));
  }, []);

  const available = info && info.version_code > 0;
  const href = available ? `${API_BASE.replace(/\/api$/, "")}${info.download_path}` : null;
  const sizeMb = info?.size ? (info.size / 1024 / 1024).toFixed(1).replace(".", ",") : null;

  return (
    <div className="min-h-screen bg-slate-950 text-slate-200 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md space-y-5">
        <div className="text-center space-y-2">
          <div className="mx-auto w-14 h-14 rounded-2xl bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center">
            <Smartphone className="w-7 h-7 text-emerald-400" />
          </div>
          <h1 className="font-outfit text-2xl font-bold text-white">App Quitaí para Android</h1>
          <p className="text-sm text-slate-400">Cobrança e atendimento na palma da mão.</p>
        </div>

        <Card className="bg-slate-900/60 border-slate-800 p-5 space-y-4">
          {!info && !error && <div className="text-sm text-slate-400 text-center">Verificando versão...</div>}
          {(error || (info && !available)) && (
            <div className="text-sm text-amber-300 text-center">
              Nenhuma versão disponível para download no momento. Tente novamente mais tarde.
            </div>
          )}
          {available && (
            <>
              <div className="text-center text-sm text-slate-400">
                Versão <span className="text-white font-semibold">{info.version_name}</span>
                {sizeMb && <> · {sizeMb} MB</>}
              </div>
              <a href={href} download data-testid="app-download-btn">
                <Button className="w-full h-12 bg-emerald-500 hover:bg-emerald-400 text-emerald-950 font-semibold text-base">
                  <Download className="w-5 h-5 mr-2" /> Baixar o app (APK)
                </Button>
              </a>
              {info.notes && <div className="text-xs text-slate-500 text-center">Novidades: {info.notes}</div>}
            </>
          )}
        </Card>

        <Card className="bg-slate-900/60 border-slate-800 p-5 space-y-3 text-sm">
          <div className="font-semibold text-white">Como instalar</div>
          <ol className="list-decimal list-inside space-y-1.5 text-slate-300">
            <li>Abra esta página <b>no celular Android</b> e toque em “Baixar o app”.</li>
            <li>Abra o arquivo baixado. Se o Android pedir, permita <b>instalar apps desta fonte</b>.</li>
            <li>Entre com o mesmo e-mail e senha do painel.</li>
            <li>Permita as <b>notificações</b> para receber o alarme da fila de atendimento.</li>
          </ol>
          <div className="flex gap-2 text-xs text-slate-500 pt-1">
            <BellRing className="w-4 h-4 shrink-0 text-amber-300" />
            Depois de instalado, o próprio app avisa quando houver versão nova.
          </div>
          <div className="flex gap-2 text-xs text-slate-500">
            <ShieldCheck className="w-4 h-4 shrink-0 text-emerald-400" />
            O app só funciona para empresas com o módulo App habilitado.
          </div>
        </Card>

        <div className="text-center">
          <Link to="/" className="text-xs text-slate-500 hover:text-slate-300 underline">Ir para o painel</Link>
        </div>
      </div>
    </div>
  );
}
